symbolsFunc